module.exports = __webpack_public_path__ + "static/media/speed_dating_icon.e9694750.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/speed_dating_icon.svg
// module id = 878
// module chunks = 0